// extracted by mini-css-extract-plugin
export default {"container":"Tp-z","brandName":"Up-z","productName":"Vp-z","productNamePdpEnhancements":"Wp-z","breakLongProductName":"Xp-z"};